<script>
  import { onMount } from "svelte";
  import { push, location } from "svelte-spa-router"; // import location too!

  onMount(() => {
    if ($location !== "/") {
      // only redirect if not already home
      push("/");
    }
  });
</script>

<!-- Optional: brief loading indicator -->
<div class="text-center mt-20 text-gray-600">Redirecting...</div>
